module.exports = __webpack_public_path__ + "static/media/muscle_back_9.6faedb10.png";